import React, { useEffect, useState } from "react";
import Pic1 from "./../../assets/img/Ramesh-Chander-Bidhan-IAS-Indian-Bureaucracy_1.jpg";
import Pic2 from "./../../assets/img/paramjitKaur.jpg";
import Pic3 from "./../../assets/img/DevRaj.jpg";
import Pic4 from "./../../assets/img/ArchanaSood.jpg";
import Pic5 from "./../../assets/img/sunilKumar.jpg";
import Pic6 from "./../../assets/img/Harish.jpg";
import { useLocation } from "react-router-dom";
import axios from "axios";
import BaseUrl from "../../base-api";
import Loader from "../Loader/Loader";

const HeadOffices = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  const [images, setImages] = useState([]);
  
      useEffect(() => {
        const fetchData = async () => {
          setLoading(true);
          try {
            const res = await axios.post(
              `${BaseUrl}/api/director/web/getAll`,
              { location: "Head Office" },
              {
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );
    
            if (res.data.status === 200 && Array.isArray(res.data.data)) {
              const processedImages = res.data.data.map((img) => ({
                id: img.key,
                location: img.location,
                imageUrl: img.file ? `data:image/png;base64,${img.file}` : "",
                name:img.name,
                designation:img.designation,
                mobileNo:img.mobileNo,
                officeNo:img.officeNo,
                email:img.email,
                address:img.address,
              }));
    
              setImages(processedImages);
            } else {
              console.error(res.data.message || "Failed to load images.");
            }
  
          } catch (error) {
            console.error(error.response?.data?.message || "An error occurred");
          }
          finally{
            setLoading(false);
          }
        };
    
        if (location.pathname) fetchData();
      }, [location.pathname]);
  return (
    <>
    {loading ? (
      <Loader />
    ) : (
    <div className="container my-3">
      <div className="abouts">
        <h5>Head Offices</h5>
      </div>

      <div className="about-box p-4 rounded shadow-lg ">
        <h6>HARYANA SEEDS DEVELOPMENT CORPORATION LIMITED</h6>

        <p>(A STATE GOVT. UNDERTAKING)</p>

        <p>BEEJ BHAWAN, BAYS 3-6, SECTOR-2, PANCHKULA</p>

        <p>PHONE : 0172-2577755</p>
        <div className="table-responsive">
          <table className="table table-striped table-bordered ">
            <tbody>
              <tr>
                <th colspan="7">DETAILS OF HEAD OFFICE OFFICERS</th>
              </tr>
              <tr>
                <td>
                  <strong>S. No.</strong>
                </td>
                <td>
                  <strong>Officer Name</strong>
                </td>
                <td>
                  <strong>Designation</strong>
                </td>
                <td colspan="2">
                  <strong>Phone</strong>
                </td>
                <td colspan="yellow" >
                  <strong>Email</strong>
                </td>
                <td>
                  <strong>Photo</strong>
                </td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>
                  <strong>Office</strong>
                </td>
                <td>
                  <strong>Residence</strong>
                </td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              {images.length > 0 ? (
                            images.map((img,index) => (
                              <tr key={img.id}>
                                <td>{index+1}</td>
                                <td>{img.name} <br/> {img.address}</td>
                                <td>{img.designation}</td>
                                <td>{img.officeNo}</td>
                                <td>{img.mobileNo}</td>
                                <td>{img.email}</td>
                                <td>
                                  {img.imageUrl ? (
                                    <img
                                      src={img.imageUrl}
                                      alt={img.location}
                                      width="150"
                                      height="100"
                                    />
                                  ) : (
                                    "No Image"
                                  )}
                                </td>
                                
                                
                                
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={7} className="text-center">
                                No Data Found.
                              </td>
                            </tr>
                          )}


{/* 
              <tr>
                <td>1</td>
                <td>Sh. Ramesh Chander Bidhan, IAS</td>
                <td>Managing Director</td>
                <td>2577582, 2577583</td>
                <td>&nbsp;</td>
                <td colspan="yellow">mdhsdcl@gmail.com</td>
                <td>
                  <img
                    alt="img-4"
                    src={Pic1} style={{width: '75px', height: '75px'}}
                    title="img-4"
                  />
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>Smt. Paramjit Kaur</td>
                <td>Chief Manager (Pers &amp; Admn.)(officiating)</td>
                <td>2572620</td>
                <td>9872123349</td>
                <td colspan="yellow">cmpahsdcl@gmail.com</td>
                <td>
                  <img
                    alt="img-5"
                    src={Pic2} style={{width: '75px', height: '75px'}}
                    title="img-5"
                  />
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>Sh.Dev Raj</td>
                <td>Chief Finance &amp; Accounts Officer(officiating)</td>
                <td>2577627</td>
                <td>9416453059</td>
                <td colspan="yellow">cfaohsdcl@gmail.com</td>
                <td>
                  <img
                    alt="img-3"
                    src={Pic3} style={{width: '75px', height: '75px'}}
                    title="img-3"
                  />
                </td>
              </tr>
              <tr>
                <td>4</td>
                <td>Mrs. Archana Sood</td>
                <td>Company Secretary</td>
                <td>2567172</td>
                <td>2772705,<br></br>9417553212</td>
                <td colspan="yellow">cshsdcl@gmail.com</td>
                <td>
                  <img
                    alt="img-1"
                    src={Pic4} style={{width: '75px', height: '75px'}}
                    title="img-1"
                  />
                </td>
              </tr>
              <tr>
                <td>5</td>
                <td>Sh.Sunil Kumar</td>
                <td>Chief Manager Marketing(officiating)</td>
                <td>2578559</td>
                <td>9416397488</td>
                <td colspan="yellow">cmmhsdc@gmail.com</td>
                <td>
                  <img
                    alt="img-7"
                    src={Pic5} style={{width: '75px', height: '75px'}}
                   
                    title="img-7"
                  />
                </td>
              </tr>
              <tr>
                <td>6</td>
                <td>Sh. Harish Kumar</td>
                <td>Chief Manager Production (Officiating)</td>
                <td>2581454</td>
                <td>9466373201</td>
                <td colspan="yellow">cmphsdcl@gmail.com</td>
                <td>
                  <img
                    alt="img-6"
                    src={Pic6} style={{width: '75px', height: '75px'}}
                    title="img-6"
                  />
                </td>
              </tr>
              <tr>
                <td>7</td>
                <td>Sh. Harish Kumar</td>
                <td>Quality Control Manager </td>
                <td>&nbsp;</td>
                <td>9466373201</td>
                <td colspan="yellow">qcmhsdc@gmail.com</td>
                <td>
                  <img
                    alt=""
                    src={Pic6} style={{width: '75px', height: '75px'}}
                    title="Harish Kumar QCM"
                  />
                </td>
              </tr> */}
            </tbody>
          </table>
        </div>
      </div>
    </div>
     )}
    </>
  );
};

export default HeadOffices;
